import React from 'react';
import { Slider } from '../Slider/Slider';
import {Homeboxes} from './Homeboxes/Homeboxes';
import staticimg from '../../images/static.jpg';
class Home extends React.Component {
    render(){
        
        return(
            <React.Fragment>
                <Slider className="Slider"  />
                <Homeboxes className="Homeboxes" />
                <section className="static">
                    <img alt="" src={staticimg}/>
                </section>
            </React.Fragment>
        );
    }
    }
    
    export {Home};


// WEBPACK FOOTER //
// ./src/components/Home/Home.js